import React from 'react';
import ErrorIcon from 'react-icons/lib/md/portable-wifi-off';
import {Link} from 'react-router-dom';

import {
    CardBlock
} from 'reactstrap';
const PageError = ({error}) => (
    <div>
        <CardBlock className="table-responsive">
            <div className="row">
                <h6 className="mb-4 col-md-8 text-uppercase pull-left">&nbsp;</h6>

            </div>
            <div className="row">
                <div className="col-md-12">
                    <div className="text-center">
                        <ErrorIcon size="70" color="#d50000"/>

                    </div>
                    <h1 className="text-center mb-2">Oops!</h1>
                    <p className="text-center">
                        {error}
                    </p>
                    <div className="text-center">
                        <Link to="/">Go to Dashboard</Link>
                    </div>
                </div>
            </div>
        </CardBlock>
    </div>
);

export default PageError;


// WEBPACK FOOTER //
// ./src/views/utils/page.error.js